import { render, staticRenderFns } from "./TourTabsDepartures.vue?vue&type=template&id=0b9ee0f4&scoped=true&"
import script from "./TourTabsDepartures.vue?vue&type=script&lang=js&"
export * from "./TourTabsDepartures.vue?vue&type=script&lang=js&"
import style0 from "./TourTabsDepartures.vue?vue&type=style&index=0&id=0b9ee0f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9ee0f4",
  null
  
)

export default component.exports